import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const GOLD = '#B8892A';
const INK = '#1A1410';
const INK3 = '#6B5840';
const BG = '#FAF8F5';

const S = {
  page: { minHeight: '100vh', background: BG, paddingBottom: 60 },
  header: {
    position: 'sticky', top: 0, zIndex: 10, background: '#fff',
    borderBottom: '1px solid #EAE5DC', display: 'flex', alignItems: 'center',
    padding: '12px 16px', gap: 12,
  },
  back: {
    border: 'none', background: 'none', fontSize: 20, cursor: 'pointer',
    color: INK, padding: 0, lineHeight: 1,
  },
  title: { fontSize: 16, fontWeight: 600, color: INK },
  body: { padding: '20px 16px', maxWidth: 640, margin: '0 auto' },
  section: { marginBottom: 28 },
  h1: { fontSize: 18, fontWeight: 700, color: GOLD, marginBottom: 16 },
  h2: { fontSize: 15, fontWeight: 600, color: INK, marginBottom: 8 },
  p: { fontSize: 13, color: INK3, lineHeight: 1.8, marginBottom: 6, whiteSpace: 'pre-wrap' },
  ul: { fontSize: 13, color: INK3, lineHeight: 1.8, paddingLeft: 20, marginBottom: 6 },
};

export default function HelpSelectionGuide() {
  const navigate = useNavigate();
  const location = useLocation();
  const handleBack = () => {
    if (location.state?.from) navigate(location.state.from);
    else navigate(-1);
  };
  return (
    <div style={S.page}>
      <div style={S.header}>
        <button style={S.back} onClick={handleBack}>&larr;</button>
        <span style={S.title}>选品须知</span>
      </div>
      <div style={S.body}>
        <div style={S.section}>
          <h2 style={S.h1}>二、选品须知</h2>

          <h3 style={S.h2}>1. 商品状态说明</h3>
          <p style={S.p}>
            代拍商品多为日本中古商品，并非全新品。
          </p>
          <p style={S.p}>
            中古商品可能存在轻微划痕、磨损、氧化、变色、污渍、维修痕迹、尺寸误差、重量误差、附件缺失、盒证不全等情况。
          </p>
          <p style={S.p}>
            商品状态以拍卖会、卖家或平台公开图片及描述为准。
          </p>
          <p style={S.p}>
            客户如对品相、尺寸、颜色、重量、附件、证书等要求较高，请在委托前提前说明并确认。
          </p>

          <h3 style={S.h2}>2. 鉴定及配套服务</h3>
          <p style={S.p}>
            云川中古除代拍服务外，也可根据客户需求提供后续配套服务，包括但不限于：
          </p>
          <ul style={S.ul}>
            <li>珠宝鉴定证书</li>
            <li>宝石鉴定</li>
            <li>改圈改号</li>
            <li>清洗保养</li>
            <li>维修翻新</li>
            <li>重新电镀</li>
            <li>包装加固</li>
            <li>国际运输协助</li>
          </ul>
          <p style={S.p}>
            以上配套服务根据实际需求另行报价，客户确认后安排。
          </p>
        </div>
      </div>
    </div>
  );
}
